<template>

    <div>
        <h2 class="h5">{{ label }} :</h2>
        <div class="form-group" :class="{ dormant: choices.length < 1 }">
            <select multiple="multiple"
                    :size="size"
                    :name="internalFormAction?'codes[]':''"
                    class="form-control multiple-select-column-no-action"
                    @change.stop="selectItems"
                    tabindex="0"
                    ref="sel"
                    :autofocus="initialFocus"
                    :aria-label="helpLabel + ' pour ' + label"
            >
                <option v-for="(choice, index) of choices" :key="choice.code" :value="choice.code" v-html="choice.name"></option>
            </select>
        </div>
        <p><small><em v-if="shouldDisplayHelp">{{ helpLabel }}</em>&nbsp;</small></p>
    </div>

</template>

<script>
import { size, forEach, indexOf } from 'lodash';
import { mapState } from 'vuex';

export default {
    name: 'multiple-select-column-no-action',

    props: {
        source: String,
        label: String,
        initialSelected: Array,
        size: {
            type: Number,
            default: 20,
        },
        internalFormAction: {
            type: Boolean,
            default: false,
        },
        initialFocus: Boolean,
    },

    data ()
    {
        return {
            selectCount: this.initialSelected.length,
            helpLabel: 'Sélectionnez une ou plusieurs lignes',
        };
    },

    mounted ()
    {
        forEach(this.$refs.sel.options, option =>
        {
            if (
                indexOf(this.initialSelected, parseInt(option.value, 10)) >= 0
            )
            {
                $(option).prop('selected', true);
            }
        });
        this.selectCount = this.initialSelected.length;
        // Synchronise initial Vuex state:
        this.$store.commit('SET_SELECTED_PROVINCE_REGIONS', [
            this.source,
            this.initialSelected,
        ]);
    },

    computed: {
        shouldDisplayHelp ()
        {
            if (this.selectCount > 0)
            {
                return false;
            }
            return size(this.choices) > 1;
        },

        ...mapState({
            choices (state)
            {
                this.selectCount = 0;
                return state[this.source];
            },
        }),
    },

    methods: {
        getSelectedOptions ()
        {
            // Make this cross-browser compatible:
            return $(this.$refs.sel).find(':selected');
        },

        selectItems ()
        {
            const selectedOptions = this.getSelectedOptions();

            if (
                selectedOptions.length === 1 &&
                selectedOptions.eq(0).val() === ''
            )
            {
                this.selectCount = 0;
                this.$store.dispatch('SELECT_MULTIPLE_OPTIONS_FOR', [
                    this.source,
                    [],
                ]);
            }
            else
            {
                this.selectCount = selectedOptions.length;
                this.$store.dispatch('SELECT_MULTIPLE_OPTIONS_FOR', [
                    this.source,
                    selectedOptions,
                ]);
            }
        },
    },
};
</script>

<style scoped>
    .dormant {
        pointer-events: none;
        opacity: 0.2;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/multiple-select-column-no-action.vue